import tccf7 from './lib/tccf7.js';

/*----------------------------------------
  実行
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wpcf7')?.forEach(elem => { 
    const topCustomContactForm7 = new tccf7(elem);
  });
});